var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'minimal-layout': true,
    'minimal-layout-small': _vm.size === 'small',
    'minimal-layout-medium': _vm.size === 'medium',
    'minimal-layout-large': _vm.size === 'large'
  }},[_c('div',{staticClass:"minimal-body"},[_c('div',{staticClass:"minimal-logo"},[_c('img',{attrs:{"src":_vm.$store.state.metadata.logoLight,"alt":_vm.$store.state.metadata.appName}})]),_c('content-box',[_vm._t("default")],2)],1),_c('div',{staticClass:"minimal-language"},[_c('language-dropdown')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }